<template>
  <div class="search-filters-container">
    <div class="clear-filter-wrapper">
      <button 
        v-if="!hideClearFilters" 
        @click="clearFilters" 
        class="clear-filter-btn"
        :class="{ 'clear-filter-btn--disabled': disableClearFilters }"
        :disabled="disableClearFilters"
      >
        <i class="ri-close-line"></i> Clear Filters
      </button>
    </div>
    <div class="filters-wrapper">
    
      Filter by
      <FilterMenuBox 
        :disableFilterMenuBox="searchInProgress"
        key="creators" 
        v-on:apply-filter="applyFilter" 
        v-on:remove-filter="onRemoveFilters" 
        ref="creatorsFilterRef" 
        type="creators" 
        :data="reelCreators"
      />
      <FilterMenuBox  
        :disableFilterMenuBox="searchInProgress"
        key="time" 
        v-on:apply-filter="applyFilter" 
        v-on:remove-filter="onRemoveFilters" 
        ref="timeFilterRef" 
        type="time" 
        :data="timeOptions"
      />
    </div>
  </div>
</template>

<script>
import FilterMenuBox from '@/views/search/components/FilterMenuBox.vue'
import SessionsAPI from '@/api/sessions/sessions.js';
import { mapState } from "vuex";

export default {
    components: { FilterMenuBox },
    props: {
        // clear filter cta is visible but disabled
        disableClearFilters: {
            default: false
        },
        // clear filter cta is hidden
        hideClearFilters: {
            default: false
        },
        searchInProgress:{
            default: false
        }
    },
    computed: {
        ...mapState([
            "userWorkspace",
        ]),
    },
    data() {
        return {
            reelCreators: [],
            timeOptions: [
                { id: '7d', name: 'Last 7 days' },
                { id: '1m', name: 'Last 30 days' },
                { id: '3m', name: 'Last 90 days' },
                { id: '6m', name: 'Last 6 months' },
                { id: '12m', name: 'Last year' }
            ],
        }
    },
    mounted() {
        this.getCreatorsList()
    },
    methods: {
        clearFilters() {
            this.$refs.creatorsFilterRef.selectedItems = []
            this.$refs.timeFilterRef.selectedItems = []
            this.$emit('clear-filters')
        },
        onRemoveFilters(filter) {
            this.$emit('remove-filters', filter)
        },
        applyFilter(filter, filterData, filterType="any_of") {
            console.log('applyfilter', filter, filterData)
            // Pass filter data as-is (same structure as ProjectSearchFilters)
            // Transformation will happen in the API layer (reels.js)
            const filterObject = {
                [filter]: {
                    "type": filterType,
                    "data": filterData
                }
            }
            console.log('filter params: ', filterObject)
            this.$emit(`apply-${filter}-filter`, filterObject)
        },
        async getCreatorsList() {
            try {
                const getFileCreatorsResponse = await SessionsAPI.getFileCreators()
                console.log('getCreatorsList response: ', getFileCreatorsResponse)
                if (getFileCreatorsResponse.status === 'success') {
                    this.reelCreators = getFileCreatorsResponse.data.file_creators || []
                } else {
                    console.error('Error in response:', getFileCreatorsResponse.error)
                    this.reelCreators = []
                }
            } catch (error) {
                console.error('Error fetching creators:', error)
                this.reelCreators = []
            }
        }
    }
}
</script>

<style scoped>
.search-filters-container {
    display: flex;
    align-items: center;
    gap: 8px;
    color: var(--neutrals-400, #999);
    font-family: Inter;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
}

.clear-filter-wrapper {
    display: flex;
    align-items: center;
}

.filters-wrapper {
    display: flex;
    align-items: center;
    gap: 4px;
}

.clear-filter-btn {
    padding: 6px;
    color: #c53030;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 4px;
}

.clear-filter-btn--disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.clear-filter-btn i {
    font-size: 14px;
}
</style>

